import React from 'react'
import "./Companies.css";

function Companies() {
    return (
        <div>
            <section className='c-wrapper'>
                <div className='paddings innerWidth flexCenter c-container'>
                    <img src='./prologis.png' alt='Prologis' />
                    <img src='./tower.png' alt='Tower' />
                    <img src='./equinix.png' alt='Equinix' />
                    <img src='./realty.png' alt='Realty' />


                </div>
            </section>
        </div>
    )
}

export default Companies
